import { BookletList } from "@/@types/Booklet";
import Link from "next/link";
import { FallbackImage } from "../common";
import NoContent from "../common/NoContent";
import IconSprite from "../common/IconSprite";

type Props = {
  bookletsList?: BookletList | undefined;
};

export default function BookletsListCard({ bookletsList }: Props) {
  if (
    !bookletsList ||
    !bookletsList.data ||
    !bookletsList.data.booklets ||
    bookletsList.data.booklets.length === 0
  ) {
    return <NoContent />;
  }

  return (
    <div className="grid grid-cols gap-6 sm:grid-cols-2 lg:grid-cols-2 w-full ">
      {bookletsList.data.booklets.map((booklet) => {
        const formatDate = booklet.date ? booklet.date : '';

        const bookletLink = `/literatura/${booklet.category_slug}/${booklet.slug}`;

        return (
          <Link
            key={booklet.slug}
            href={bookletLink}
            className="h-[100%] border bg-white shadow-md overflow-hidden hover:shadow-lg transition-shadow duration-300 flex flex-col"
          >
            <div className="flex flex-row h-[100%]">
              <div className="w-1/3 [@media(max-width:1249px)]:h-44 aspect-[2/3] flex items-center justify-left">
                <FallbackImage
                  width={550}
                  height={550}
                  src={booklet.image || "/images/img_no_found.jpg"}
                  alt={booklet.title || "Título no disponible"}
                  className={`h-full w-auto object-fill lg:object-contain`}
                />
              </div>

              <div className="w-2/3 p-4 lg:flex lg:flex-col justify-between">
                <div>
                  <p className="text-xs lg:text-sm font-bold bg-dark02 lg:bg-black text-white inline-block px-2 lg:px-3 py-1 rounded-md uppercase mb-4 w-fit">
                    {booklet.category}
                  </p>

                  <h3
                    className="text-base lg:text-lg font-bold text-dark01 line-clamp-2 uppercase overflow-hidden text-ellipsis"
                  >
                    {booklet.title}
                  </h3>
                  <p className="text-md text-dark01 line-clamp-2 mt-2">{booklet.description}</p>
                </div>

                <div className="[@media(max-width:1249px)]:hidden lg:flex justify-between items-end mt-4 text-dark01">
                  <span className="text-sm">{formatDate}</span>
                  <span className="text-sm font-bold hover:underline flex items-center gap-1">
                    SEGUIR LEYENDO
                    <IconSprite id="ic_arrow_right" className="w-3 h-3" />
                  </span>
                </div>
              </div>

            </div>
            <div className="w-full flex [@media(min-width:1250px)]:hidden justify-between items-center p-4 text-dark01">
              <span className="text-sm">{formatDate}</span>
              <span className="text-sm font-bold hover:underline flex items-center gap-1">
                SEGUIR LEYENDO
                <IconSprite id="ic_arrow_right" className="w-3 h-3" />
              </span>
            </div>
          </Link>
        );
      })}
    </div>
  );
}
